var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6191 19.4998H44.911",
    stroke: "#00093A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6191 43.8879H44.911",
    stroke: "#00093A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6191 31.6926H44.911",
    stroke: "#00093A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1979 14.0798H15.7804C15.0317 14.0798 14.4248 14.6867 14.4248 15.4354V20.8529C14.4248 21.6016 15.0317 22.2085 15.7804 22.2085H21.1979C21.9465 22.2085 22.5535 21.6016 22.5535 20.8529V15.4354C22.5535 14.6867 21.9465 14.0798 21.1979 14.0798Z",
    stroke: "#00093A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6691 12.9648H21.4725L18.9258 15.5116C18.1277 14.7993 16.9031 14.8255 16.136 15.5926C15.3427 16.3859 15.3427 17.6724 16.136 18.4657L17.4916 19.8213C17.8894 20.2192 18.4088 20.4169 18.9282 20.4169C19.4475 20.4169 19.9692 20.2192 20.3647 19.8213L23.6691 16.517V12.9648Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1338 17.4676L18.4894 18.8231L23.2327 14.0798",
    stroke: "#00093A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1979 26.2751H15.7804C15.0317 26.2751 14.4248 26.8821 14.4248 27.6307V33.0482C14.4248 33.7969 15.0317 34.4038 15.7804 34.4038H21.1979C21.9465 34.4038 22.5535 33.7969 22.5535 33.0482V27.6307C22.5535 26.8821 21.9465 26.2751 21.1979 26.2751Z",
    stroke: "#00093A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5519 25.2769H21.3553L18.8086 27.8236C18.0105 27.1113 16.7859 27.1375 16.0188 27.9046C15.2255 28.6979 15.2255 29.9844 16.0188 30.7777L17.3744 32.1333C17.7722 32.5312 18.2916 32.7289 18.811 32.7289C19.3303 32.7289 19.8521 32.5312 20.2475 32.1333L23.5519 28.829V25.2769Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1338 29.6605L18.4894 31.0161L23.2327 26.2751",
    stroke: "#DA291C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1979 38.468H15.7804C15.0317 38.468 14.4248 39.0749 14.4248 39.8236V45.2411C14.4248 45.9898 15.0317 46.5967 15.7804 46.5967H21.1979C21.9465 46.5967 22.5535 45.9898 22.5535 45.2411V39.8236C22.5535 39.0749 21.9465 38.468 21.1979 38.468Z",
    stroke: "#00093A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6974 37.3247H21.5008L18.9541 39.8715C18.156 39.1591 16.9315 39.1853 16.1643 39.9525C15.371 40.7458 15.371 42.0323 16.1643 42.8256L17.5199 44.1812C17.9178 44.579 18.4371 44.7768 18.9565 44.7768C19.4758 44.7768 19.9976 44.579 20.393 44.1812L23.6974 40.8768V37.3247Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1338 41.8557L18.4894 43.2113L23.2327 38.468",
    stroke: "#00093A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1412 8H10.8588C9.27995 8 8 9.27995 8 10.8588V49.1412C8 50.7201 9.27995 52 10.8588 52H49.1412C50.7201 52 52 50.7201 52 49.1412V10.8588C52 9.27995 50.7201 8 49.1412 8Z",
    stroke: "#00093A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.1ed78da03a2841144a9e831116592498.svg";
export { ForwardRef as ReactComponent };